import { useIsCircleAiPageRoute } from "@circle-react/components/CircleAi/useIsCircleAiPageRoute";
import {
  useIsCommunityAdmin,
  usePunditUserContext,
} from "@circle-react/contexts/punditUserContext";
import { useIsCaiSufEnabled } from "@circle-react/contexts/punditUserContext";

// Mobile parity: follow-up.
export const useSignUpQuestionsPending = (): boolean => {
  const { isAiRoute } = useIsCircleAiPageRoute();
  const isCaiSufEnabled = useIsCaiSufEnabled();
  const isAdmin = useIsCommunityAdmin();
  const hasAnsweredSignUpQuestions = Boolean(
    usePunditUserContext().currentCommunity?.basic_questions_completed,
  );

  return isCaiSufEnabled && isAiRoute && isAdmin && !hasAnsweredSignUpQuestions;
};
